<template>
  <!-- using autocomplete value "new-password" instead of "off" seems to disable autocomplete better in some browsers. -->
  <v-select
    :id="id"
    :options="options"
    :class="selectClass"
    :placeholder="placeholder"
    :label="selectLabel"
    :value="value"
    @search="onSearch"
    :filterable="false"
    @input="(location) => $emit('input', location)"
    autocomplete="new-password"
    :disabled="disabled"
  >
    <template #option="location">
      <div>
        <span>{{ location.store_number }}</span>
        <span v-if="location.name &&location.name != location.store_number">&nbsp;- {{ location.name }}</span>
        <span v-if="!activeOnly && !!location.deleted_at">&nbsp;(Inactive)</span>
        <span>&nbsp;- {{ (location.clients || []).map((client) => client.code).join(", ") }}</span>
      </div>
      <div class="font-size-sm text-secondary">
        {{ location.street }}, {{ location.city }}, {{ location.state }}
      </div>
    </template>
    <template #no-options="{ search, searching }">
      <template v-if="searching">
        No results found for
        <em>{{ search }}</em>
      </template>
      <em
        style="opacity: 0.7"
        v-else
      >Type to search for locations</em>
    </template>

    <template #selected-option="location">
      <span>{{ location.store_number }}</span>
      <span v-if="location.name && location.name != location.store_number">&nbsp;- {{ location.name }}</span>
      <span v-else>&nbsp;- {{ location.city }}, {{ location.state }}</span>
    </template>
  </v-select>
</template>
<script>
import { debounce as _debounce } from 'lodash';

export default {
  name: 'LocationsSelect',
  props: {
    value: Object,
    id: {
      type: String,
      default: 'location',
    },
    clientId: {
      type: [String, Number],
    },
    activeOnly: {
      type: [Boolean],
      default: true,
    },
    selectLabel: {
      type: String,
      default: 'store_number',
    },
    selectClass: {
      type: Object,
      default: () => new Object(),
    },
    placeholder: {
      type: String,
      default: 'Search by address or store #',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: [],
      perPage: 20,
    };
  },
  methods: {
    onSearch(text, loading) {
      if (text.length) {
        loading(true);
        this.filterLocations(text, loading, this);
      }
    },
    filterLocations: _debounce((text, loading, vm) => {
      const params = {
        text: text,
        client_id: vm.clientId,
        sort_by: 'store_number',
        sort_desc: false,
        per_page: vm.perPage,
      };
      if (vm.activeOnly) {
        params.active = true;
      }
      vm.$locationsAPI.getLocations(params).then((response) => {
        vm.options = response.locations;
        loading(false);
      });
    }, 500),
  },
  watch: {
    clientId(newVal, oldVal) {
      if (newVal != oldVal) {
        this.options = [];
      }
    },
  },
};
</script>
